import expensesGraphic from "@/shared/assets/illustrations/ongoing-estate-expenses.svg";
import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { FuneralCostsReview } from "../components/FuneralCostsReview";
import { AddFuneralCost } from "../components/AddFuneralCost";

export function createFuneralCostsScreens(firstName: string): FlowScreenConfig[] {
  return [
    {
      id: "expenses_intro",
      layout: "full",
      imageSrc: expensesGraphic,
      imageSize: "md",
      imagePosition: "right",
      verticalCenter: true,
      sectionLabel: "Section 7",
      maxWidth: "4xl",
      title: `Let's document ${firstName}'s ongoing estate expenses`,
      subtitle:
        "We'll help you track funeral costs, ongoing bills, and other out-of-pocket expenses that may be reimbursable from the estate.",
      getButtonText: () => "Get started",
    },
    {
      id: "funeral_costs_review",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: FuneralCostsReview,
      shouldDisplay: ({ answers }) =>
        !answers["add_funeral_cost"] && answers["funeral_costs_review"] !== "none",
    },
    {
      id: "add_funeral_cost",
      layout: "full",
      textAlign: "center",
      maxWidth: "4xl",
      title: "Add funeral costs",
      subtitle: "Enter the details you have. You can always come back to add more.",
      hideButton: true,
      customComponent: AddFuneralCost,
      shouldDisplay: ({ answers }) =>
        answers["add_funeral_cost"] === "adding" ||
        (answers["funeral_costs_review"] !== "found" && answers["add_funeral_cost"] !== "done"),
    },
    {
      id: "funeral_costs_manage",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: FuneralCostsReview,
      shouldDisplay: ({ answers }) =>
        answers["funeral_costs_review"] === "found" && answers["funeral_costs_manage"] === "yes",
    },
  ];
}
